/* global foodbox */
import _ from "lodash";
import $ from 'jquery';

export function gen(tag,props){
    return $(tag).attr(props)
}
export function icon(name){
    return gen('span').attr({
        'class':'icon',
        'data-icon' : name,
    })
}
export function isDefined(val){
    return typeof val !== "undefined"
}

export function isRtl(val){
    return foodbox.lang === "he_IL"
}

export function isEmpty(any) {
    return (any !== true && !_.isFinite(any) && _.isEmpty(any));
}
export function isMobile() {
    return foodbox['device']['mobile'];
}

export function scroll_to(to = 0, duration = 250){
    let position = to
    const header = $('#site-header');
    if(header.hasClass('fixed')){
        position -= header.outerHeight()
    }
    $('body,html').animate({scrollTop: position}, duration);

}

export function isInViewport(element, allInView = false) {
    if (isEmpty(element)) {
        return false;
    }
    if (typeof $ === "function" && element instanceof $) {
        element = element[0];
    }

    const rect = element.getBoundingClientRect();

    if (allInView) {
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= $(window).height() &&
            rect.right <= $(window).width()
        );
    }

    return (
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < $(window).width() &&
        rect.top < $(window).height()
    );
}



export function dragToScroll(ele){
        ele.style.cursor = 'grab';
        let pos = { top: 0, left: 0, x: 0, y: 0 };

        const mouseDownHandler = function (e) {
            e.stopPropagation();
            ele.style.cursor = 'grabbing';
            ele.style.userSelect = 'none';

            pos = {
                left: ele.scrollLeft,
                top: ele.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };

            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x;
            const dy = e.clientY - pos.y;

            // Scroll the element
            ele.scrollTop = pos.top - dy;
            ele.scrollLeft = pos.left - dx;
        };

        const mouseUpHandler = function () {
            ele.style.cursor = 'grab';
            ele.style.removeProperty('user-select');

            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

        ele.addEventListener('mousedown', mouseDownHandler);

}
